import { PropsWithChildren } from 'react';

import EditIcon from '@/shared/assets/edit.png';

export const ProjectPropertiesMenuLayout = ({
  children,
}: PropsWithChildren) => {
  return (
    <div className="flex w-full flex-1 flex-col gap-8 lg:flex-row lg:items-start">
      {children}
    </div>
  );
};

export const ProjectPropertiesMenuCol = ({ children }: PropsWithChildren) => {
  return <div className="flex flex-col gap-4 overflow-x-clip">{children}</div>;
};

export const ProjectPropertiesMenuItem = ({
  children,
  isEditable,
  onEdit,
  span,
  aspectRatio = '170/80',
}: PropsWithChildren & {
  isEditable?: boolean;
  onEdit?: () => void;
  span?: 1 | 2;
  aspectRatio?: string;
}) => {
  const aspectRatioClass =
    aspectRatio === '170/216'
      ? 'aspect-[170/216]'
      : aspectRatio === '340/80'
        ? 'aspect-[340/80]'
        : 'aspect-[170/100]';

  return (
    <div
      className={`relative ${aspectRatioClass} ${
        aspectRatio === '170/216' ? 'min-h-[216px]' : 'min-h-[100px]'
      } w-full min-w-[170px] overflow-hidden rounded-[12px] p-px ${
        span === 2 ? 'lg:col-span-2' : ''
      }`}
      style={{
        background:
          'linear-gradient(to bottom, rgba(255,255,255,0) 12.871%, rgba(255,255,255,0.06) 87.632%)',
      }}
    >
      <div className="relative flex h-full flex-col rounded-[12px] bg-transparent px-[16px] py-[20px] shadow-[0px_20px_50px_0px_inset_rgba(255,255,255,0.01)]">
        <div className="flex flex-1 flex-col items-center justify-center gap-[6px] text-center">
          {children}
        </div>
        {isEditable && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.();
            }}
            className="absolute right-2 top-2 z-10 flex size-4 items-center justify-center rounded text-custom-grey transition-colors hover:text-white"
            aria-label="Edit"
          >
            <img src={EditIcon} alt="Edit" className="size-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export const ProjectPropertiesMenuItemPrefix = ({
  children,
  className,
}: PropsWithChildren & { className?: string }) => {
  return (
    <div
      className={`flex flex-row items-center justify-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap text-[12px] text-custom-grey ${className || ''}`}
    >
      {children}
    </div>
  );
};

export const ProjectPropertiesMenuItemValue = ({
  children,
}: PropsWithChildren) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-1 overflow-hidden text-ellipsis text-[13px] text-white">
      {children}
    </div>
  );
};
